import focusInput from '@intercom/embercom-composer/lib/focus-input';
import Facebook from '@intercom/embercom-composer/blocks/types/facebook-like-button';
import $ from 'jquery';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['ic-popup', 'ic-popup-left', 'ic-popup-short', 'is-light-theme', 'composer-facebook-inserter'],
  didInsertElement() {
    this._super(...arguments);
    focusInput($('input:first', this.element));
  },
  actions: {
    insert(page) {
      let match = page.match('(?:https?:)//(?:www.)?facebook.com/(.+)');
      if (match) {
        page = match[1];
      }
      if (!Em.isEmpty(page)) {
        let block = Facebook.create({
          config: this.get('config'),
          url: `http://www.facebook.com/${page}`
        });
        let options = {
          index: this.get('hoverCoordinates.insertionIndex'),
          selectNewBlock: false
        };
        this.insertBlock(block, options);
      }
    }
  }
});